import {BaseColumn, BaseColumnConfig} from './base-column.model';

export class TextColumn extends BaseColumn {
  limit: number;

  constructor(title: string,
              config: TextColumnConfig) {
    super(title,
      {
        property: config.property
      });
    this._columnType = 'TextColumn';
    this.limit = config.limit || 30;
  }

  get(element: any): any {
    if (!element[this.property]) {
      return null;
    }

    return element[this.property].length > this.limit ? (element[this.property].slice(0, this.limit) + '...') : element[this.property];
  }
}

export interface TextColumnConfig extends BaseColumnConfig {
  limit?: number;
}
